import moment from 'moment';
import api from '../../utils/apiFetch';

const path = 'stats';

const addOneDayToEndDate = (endDate) => {
  if (!endDate) return endDate;

  if (typeof endDate === 'string') {
    const formats = ['MM/DD/YYYY', 'YYYY-MM-DD', 'MM/DD/YYYY HH:mm'];
    let parsed = moment(endDate, formats, true);

    if (!parsed.isValid()) {
      parsed = moment(endDate);
    }
    if (!parsed.isValid()) {
      return endDate;
    }

    const nextDay = parsed.add(1, 'day');
    if (endDate.includes(':')) {
      return nextDay.format('MM/DD/YYYY HH:mm');
    }
    if (endDate.includes('-')) {
      return nextDay.format('YYYY-MM-DD');
    }
    return nextDay.format('MM/DD/YYYY');
  }

  const parsed = moment(endDate);
  return parsed.isValid() ? parsed.add(1, 'day').toDate() : endDate;
};

export default {
  getMerchantStats: () => api.get(`${path}/merchanttotals`),
  getChartStats: (params = {}) => {
    const { month, year, ...queryParams } = params;
    if (queryParams.endDate) {
      queryParams.endDate = addOneDayToEndDate(queryParams.endDate);
    }
    return api.get(`${path}/chart?${api.serialize(queryParams)}`);
  },
  getMerchantStoreCreditStats: () => api.get(`${path}/store-credit-totals`),
  getMerchantMembershipStats: () => api.get(`${path}/membership-totals`),
  getMerchantLoyaltyStats: () => api.get(`${path}/loyalty-totals`),
  getMerchantCouponStats: () => api.get(`${path}/coupon-totals`),
  getMerchantTicketStats: () => api.get(`${path}/ticket-totals`),
};
